export enum FolderType {
  individual = 1,
  pedigree = 6,
}
